<script lang="ts">
      let { item } = $props()
</script>

<div class="w-auto h-full p-1">
      <div class="contact group w-full h-full flex flex-col">
            <img src={item.image?.sizes?.large?.url ?? item.image?.url ?? ""} alt="flora" class="block aspect-[1/.9] w-full object-cover grayscale group-hover:grayscale-0 img-trans" />
            <div class="h-full mt-auto px-2 pt-4 pb-4 bg-[#f2F2F2] flex flex-col">
                  <h1 class="block text-xl font-[300]">{item.name}</h1>
                  <div class="content font-['nunito-sans'] text-[#414141] font-semibold">
                        <p>{item.role}</p>
                  </div>
                  
                  <div class="content font-['nunito-sans'] text-[#414141]">
                        {#if item.email}
                              <p><a href="mailto:{item.email}" class="trans hover:text-[var(--df-primary)]">{item.email}</a></p>
                        {:else}
                              <!--<br />-->
                        {/if}
                        {#if item.telephone}
                              <p><a href="tel:{item.telephone}" class="trans hover:text-[var(--df-primary)]">{item.telephone}</a></p>
                        {:else}
                              <!--<br />-->
                        {/if}
                  </div>
            </div>
      </div>
</div>

<style lang="postcss">
      .contact {
            @apply flex-shrink rounded-xl overflow-hidden shadow-md;
            transition: transform 0.3s ease-in-out;
      }

      .trans {
        transition: all 0.2s ease-in-out;
      }
      
      .img-trans {
        
        transition: all 0.7s ease-in-out;
      }
</style>
